const accessTokenStorageKey = 'accessToken';

export const getAccessToken = () => {
  return localStorage.getItem(accessTokenStorageKey);
};
